/**
 * Cómo se llama el portal.
 *
 * Se llamaba «Vacaciones», que es lo que era: un portal para pedir días. Desde
 * el reenfoque es KNPeople —personas, organización, ausencias, comunicación—, y
 * la barra lateral, la cabecera del teléfono, la pantalla de acceso y la pestaña
 * del navegador seguían diciendo el nombre viejo. JC lo pidió el 7 oct 2026.
 *
 * Con punto medio, igual que «Kn·Blog». En un solo sitio porque lo dicen seis
 * pantallas, y la séptima vez que alguien lo escriba a mano saldrá «KnPeople».
 * La pestaña del navegador no puede leer de aquí —es `index.html`— y lo repite.
 *
 * Los correos lo dicen también, en su cabecera, pero desde su propia copia: el
 * servidor no importa de aquí. Ver `PRODUCT_NAME` en `functions/src/mail.ts`. Las
 * plantillas de WhatsApp dicen «KnPeople», sin punto, porque así las aprobó Meta.
 */
export const PRODUCT_NAME = 'Kn·People';
